import { ActionContext } from 'vuex'
import apiDataPool from '@/api/datapool'
import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'
import { IDataPoolState } from './state';
import { ApiResultCode } from '@/models/response/AlrBase';
import { AloDataPoolItem } from '@/models/alo/AloDataPoolItem';
import { ApiActionType } from '@/enum/ApiActionType';


export class DatapoolAction {
  public [types.DATAPOOL_REQUEST](context: ActionContext<IDataPoolState, IRootState>,
                                  {usrId=null,keyFilter=null,useContains=false} : {usrId:null|number,keyFilter:string|null,useContains:boolean}) {        
    return new Promise((resolve, reject) => {
      context.commit(types.DATAPOOL_REQUEST)
      apiDataPool.getDataPool({usrId,keyFilter,useContains})
        .then(resp => {          
          if(resp.data.resultCode == ApiResultCode.Ok){
            const dataPoolItems = resp.data.data
            context.commit(types.DATAPOOL_SUCCESS, dataPoolItems)
            resolve(dataPoolItems)
          }
          else{
            context.commit(types.DATAPOOL_ERROR)     
            reject()     
          }
        })
        .catch(resp => {
          context.commit(types.DATAPOOL_ERROR)     
          reject()   
        })
    });
  }
  public [types.DATAPOOL_ENSURE](context: ActionContext<IDataPoolState, IRootState>,
                                    {usrId=null,fullKey=null}:{usrId?:null|number,fullKey:string|null}){  
    return new Promise((resolve, reject) => {   
      if(fullKey == null)  {
        reject()
      }
      else {
        const dataPool = context.getters.dataPoolItemsValueByKey[fullKey!]
        if(!dataPool) {
          context.commit(types.DATAPOOL_ENSURE,{usrId,fullKey})
          context.dispatch(types.DATAPOOL_REQUEST,{usrId,keyFilter:fullKey}).then((data)=> {          
            resolve(data)
          })
        }
        else{        
          resolve(dataPool)
        }
      }
    });
  }

  public [types.DATAPOOL_MSG_ACCUEIL_REQUEST](context: ActionContext<IDataPoolState, IRootState>) {        
    return new Promise((resolve, reject) => {
      context.commit(types.DATAPOOL_MSG_ACCUEIL_REQUEST)
      apiDataPool.getMessageAccueil()
        .then(resp => {          
          if(resp.data.resultCode == ApiResultCode.Ok){
            const dataPoolItem = resp.data.data
            context.commit(types.DATAPOOL_MSG_ACCUEIL_SUCCESS, dataPoolItem)
            resolve(dataPoolItem)
          }
          else{
            context.commit(types.DATAPOOL_MSG_ACCUEIL_ERROR)     
            reject()     
          }
        })
        .catch(resp => {
          context.commit(types.DATAPOOL_MSG_ACCUEIL_ERROR)     
          reject()   
        })
    });
  }  
  
  public [types.DATAPOOL_UPDATE_REQUEST](context: ActionContext<IDataPoolState, IRootState>,
                                         datapool:AloDataPoolItem){
    return new Promise((resolve, reject) => {
      context.commit(types.DATAPOOL_UPDATE_REQUEST,datapool)      
      
      //on tente de mettre à jour l'id avec celui de la clé existante
      const storeDataPool = context.getters.dataPoolItemsDic[datapool.dtaKey]
      if(storeDataPool) {
        datapool.dtaId = datapool.dtaId || storeDataPool.dtaId
        datapool.dtaNote = datapool.dtaNote || storeDataPool.dtaNote
      }     

      apiDataPool.updateDataPool(datapool)
        .then(resp => { 
          const dataPoolItem = resp.data.data
          context.commit(types.DATAPOOL_UPDATE_SUCCESS, dataPoolItem)
          resolve(resp)
        })
        .catch(resp => {
          context.commit(types.DATAPOOL_UPDATE_ERROR,datapool)        
          reject()
        })
    })
  }

  public [types.DATAPOOL_UPDATE](context: ActionContext<IDataPoolState, IRootState>,
                                {dataPool,actionType} : {dataPool:AloDataPoolItem,actionType:ApiActionType}){
    return new Promise((resolve, reject) => {  
      if(actionType != ApiActionType.Deleted) {
        context.commit(types.DATAPOOL_UPDATE_SUCCESS, dataPool)
      }
      else{
        context.commit(types.DATAPOOL_DELETE, dataPool)
      }      
    })
  }
}

export default util.classToObject(DatapoolAction)